class ProxyingCustomerInfoPanelController {

  constructor(localStorageService) {
    this.name = 'proxyingCustomerInfoPanel';
    this.localStorageService = localStorageService;
  }

  getCustomerInfo() {
    let customer = ' ';
    let fields = [].slice.call(arguments);
    let isImpersonating = this.localStorageService.get('isImpersonating');
    let hasCustomerInfo = this.localStorageService.get('impersonatingCustomer');

    if(isImpersonating && !!hasCustomerInfo) {
      fields.forEach((field)=> {
        customer += `${hasCustomerInfo[field]} `;
      });
      return customer;
    }
  }
}

ProxyingCustomerInfoPanelController.$inject = ['localStorageService'];

export default ProxyingCustomerInfoPanelController;



// WEBPACK FOOTER //
// ./app/components/proxyingCustomerInfoPanel/proxyingCustomerInfoPanel.controller.js